import React,{useState} from 'react'
import ExpenseForm from './ExpenseForm';
const ExpensesEdit = () => {
    const [mode,setMode] = useState('Editing');
    return (
        <div>
            <ExpenseForm mode={mode} setMode={setMode} />
        </div>
    )
}

export default ExpensesEdit